import { FormEvent } from 'react';

export const ignoreFormSubmitEvent = (event: FormEvent): void => {
  event.preventDefault();
  event.stopPropagation();
};
